import React from 'react';
import { useTranslation } from 'react-i18next';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import PropTypes from 'prop-types';
import { Grid, Typography,Box, Container} from '@mui/material';
import Icon from '@mui/material/Icon';

const PageHeader = ({ displayText = '' }) => {
    if (displayText === "") return <div></div>;
    const { t } = useTranslation();
        
    return (
        <Container sx={{width: "100%", marginY:"2%" }} fixed >
        <Box>
        <Grid container spacing={1} alignContent="center" marginY={"20pt"}  >
            <Grid item fontSize={"2rem"}>
                <Typography fontSize={"30pt"} style={{ textAlign: 'right' }} >
                    <Icon color='primary' data-testid="header-icon" component={ArrowCircleRightIcon} fontSize='inherit' />
                </Typography>
            </Grid>
        
            <Grid item >
                <Typography variant="h2"  sx={{fontSize: "30px !important" }} fontWeight={"bold"} id="choose-network" className="title-box" style={{ textAlign: 'left' }}>
                    {t(`${displayText}`)}
                </Typography>
            </Grid>
       
         </Grid>
         </Box>
         </Container>
        );
};

PageHeader.propTypes = {
    displayText: PropTypes.string
}
 
export default PageHeader;